import React, { useState, useRef } from 'react';
import { InfoOverlay } from './InfoOverlay';
import { InfoIcon } from './InfoIcon';

interface MetricLabelProps {
  label: string;
  description?: string | React.ReactNode;
  width?: string;
}

export const MetricLabel: React.FC<MetricLabelProps> = ({
  label,
  description,
  width,
}) => {
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <div
      className="text-sm mb-2 flex align-items-center"
      style={{ color: 'var(--bq-text-secondary)' }}
    >
      <span>{label}</span>
      {description && (
        <>
          <button
            ref={buttonRef}
            type="button"
            aria-label="More info"
            className="p-link flex align-items-center justify-content-center"
            onClick={() => setIsOverlayVisible((prev) => !prev)}
            style={{
              padding: 0,
              marginLeft: '4px',
              color: 'var(--bq-text-tertiary)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = 'var(--bq-text-primary)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'var(--bq-text-tertiary)';
            }}
          >
            <InfoIcon />
          </button>
          <InfoOverlay
            triggerRef={buttonRef}
            isVisible={isOverlayVisible}
            onClose={() => setIsOverlayVisible(false)}
            width={width}
          >
            {description}
          </InfoOverlay>
        </>
      )}
    </div>
  );
};
